import { ThemeProvider } from "styled-components"
import Routes from "./routes"
import { theme } from "./theme"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { ptBR } from "date-fns/locale/pt-BR"
import { useEffect } from "react"
import getStore from "./store"
import { opensWithoutEvent } from "./utils/tb/publicPaths"

function App() {
  const store = getStore()

  useEffect(() => {
    const event = sessionStorage.getItem("event")
    const user = sessionStorage.getItem("user")

    if (user && !store.user) store.controllers.user.setData(JSON.parse(user))

    if (event) {
      if (!store.event) store.controllers.event.setData(JSON.parse(event))
    } else {
      // Link público dos ingressos e Suporte abrem sem evento escolhido.
      if (!opensWithoutEvent(window.location.pathname)) {
        window.location.href = "/eventSelect"
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStorage, store.user, store.event])

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <Routes />
      </LocalizationProvider>
    </ThemeProvider>
  )
}

export default App
